<rt-scrollable class="dialog-scroll-container" [class.is-mobile]="dialogConfig.mobileOptions">
  @if (!dialogConfig.mobileOptions) {
    <div class="dialog-scroll-content">
      <div
        class="dialog-backdrop"
        (click)="
          !dialogConfig.disableClose && !dialogConfig.disableCloseOnBackdrop ? close() : null
        "
      ></div>
      @if (dialogConfig.backdropStyle === 'cover' && dialogCloseVisible) {
        <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
      }
      <div
        class="dialog-container"
        cdkTrapFocus
        [class.vertically-centered]="dialogConfig?.containerOptions?.verticallyCentered"
      >
        <div
          [style.width]="dialogConfig.width"
          [style.maxWidth]="dialogConfig.maxWidth"
          [style.minWidth]="dialogConfig.minWidth"
          [style.height]="dialogConfig.height"
          class="dialog-content"
        >
          <ng-template cdkPortalOutlet></ng-template>
          @if (dialogConfig.backdropStyle === 'default' && dialogCloseVisible) {
            <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="dialog-scroll-content">
      <div class="dialog-container vertically-centered" cdkTrapFocus>
        <div
          [class.mobile-dialog]="dialogConfig.mobileOptions.mobileDialog"
          [class.mobile-modal]="dialogConfig.mobileOptions.mobileModal"
          [class.mobile-popup]="dialogConfig.mobileOptions.mobilePopup"
          class="dialog-content"
        >
          @if (dialogConfig.mobileOptions.mobileDialog) {
            <div class="title-container">
              <span class="view-title">{{ mobileViewTitle }}</span>
              <ng-template [ngTemplateOutlet]="dialogClose"></ng-template>
            </div>
          }
          <ng-template cdkPortalOutlet></ng-template>
        </div>
      </div>
    </div>
  }
</rt-scrollable>

<ng-template #dialogClose>
  <div
    class="dialog-close dialog-backdrop-style-{{ dialogConfig.backdropStyle }}"
    [class.mobile-close]="dialogConfig.mobileOptions"
  >
    <rt-dialog-close
      [closeButtonSize]="dialogConfig.mobileOptions ? $any('small') : $any('medium')"
      [closeTooltip]="dialogConfig.closeTooltip"
      (click)="close()"
    ></rt-dialog-close>
  </div>
</ng-template>
